import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelContainer,
  PanelHeader,
  PanelBody,
  PanelFooter,
  ControlLabel,
  Form,
  FormControl,
  Radio,
  Checkbox,
  DropdownButton,
  InputGroup,
  MenuItem,
  Button,
} from '@sketchpixy/rubix';
import IsEmail from 'isemail';
import Loader from 'react-loader';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';

import {getServiceRegion, createContract, checkEmail} from '../../api/api';
import {routeUrl} from '../routeUrl';
import CustomerType from './CustomerType';
import DeviceType from '../../constants/DeviceType';
import SideType from '../../constants/SideType';
import DisplayType from '../../constants/DisplayType';
import GenderType from '../../constants/GenderType';
import SuccessModal from './SuccesesModal/SuccessModal';
import TextInputForm from './TextInputForm/TextInputForm';
import InputValidationType from '../../constants/InputValidationType';
import ContractRegisterModal from './ContractRegisterModal/ContractRegisterModal';
import {StyledFormGroup} from './FromStyle';

const InstallmentPeriodInput = styled(NumberFormat)`
  width: 50px;
`;

const InstallmentPeriodInputGroup = styled.div`
  display: flex;
`;

const INSTALLMENT_MONTH_LIST = [
  1,
  6,
  12,
  18,
  24,
  36,
];

const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

const nextPaymentDate = moment().add(3, 'months');

@withRouter
class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role: null,
      region: 'ALL',
      roleRegion: null,
      serviceRegions: [],
      isNewCustomer: true,
      currency: '$',
      showOtSessionFee: false,
      contractInfo: {
        email: '',
        password: 'smartglove1',
        confirmPassword: 'smartglove1',
        nickname: '',
        firstName: '',
        lastName: '',
        gender: GenderType.MALE,
        birthday: null,
        devices: new Set,
        sideInfo: {},
        display: null,
        installmentPeriod: 5,
        hardwareAmount: {
          formattedValue: '',
          value: null,
        },
        otSessionAmount: {
            formattedValue: '',
            value: null,
        },
        oneTimeAmount: {
          formattedValue: '',
          value: null,
        },
        totalAmount: {
          formatted: '',
          value: null,
        },
        nextPaymentDate: nextPaymentDate.clone().toDate(),
        postalCode: ''
      },
      validationStates: {
        email: InputValidationType.NULL,
        password: InputValidationType.NULL,
        name: InputValidationType.NULL,
        gender: InputValidationType.NULL,
        birthday: InputValidationType.NULL,
        product: InputValidationType.NULL,
        display: InputValidationType.NULL,
        installmentPeriod: InputValidationType.NULL,
        amount: InputValidationType.NULL,
        nextPaymentDate: InputValidationType.NULL,
        postalCode: InputValidationType.NULL,
      },
      help: {
        email: null,
        password: null,
        confirmPassword: null,
      },
      loaded: true,
      isNeedDisplay: false,
      showSuccessModal: false,
      billingUrl: '',
      showContractExpireModal: false,
      hasActiveContract: false
    };
  }

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };

    getServiceRegion((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          serviceRegions: result.list,
          region: result.list[0].countryAlpha2Code,
        });
      }
    });
  }

  countryChangeHandler = event => {
    let region         = event.target.value;
    let currency       = this.state.currency;
    let partialInstallment  = this.state.partialInstallment;

    if (region === 'KR') {
      currency = '₩';
    } else {
      currency = '$';
    }

    if (region != 'US') {
      partialInstallment = false;
    }

    this.setState({
      region,
      partialInstallment,
      currency,
    });
  };

  customerTypeChangeHandler = (customerType) => {
    let isNewCustomer = false;
    switch (customerType) {
      case CustomerType.NEW_CUSTOMER:
        isNewCustomer = true;
        break;
      case CustomerType.EXISTING_CUSTOMER:
      default:
        isNewCustomer = false;
        break;
    }

    let help = this.state.help;
    help.email = null;
    let validationStates = this.state.validationStates;
    validationStates.email = InputValidationType.NULL;

    this.setState({
      isNewCustomer,
      validationStates,
      help,
    });
  };

  textInputChangeHandler = (event, contractInfoKey, validationKey, helpKey = null) => {
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    let help = this.state.help;
    contractInfo[contractInfoKey] = event.target.value;
    validationStates[validationKey] = InputValidationType.NULL;
    if (helpKey) {
      help[helpKey] = null;
    }
    this.setState({
      contractInfo,
      validationStates,
      help,
    });
  };

  genderTypeChangeHandler = genderType => {
    let contractInfo = this.state.contractInfo;
    contractInfo.gender = genderType;

    this.setState({
      contractInfo,
    });
  };

  birthdayChangeHandler = date => {
    let contractInfo = this.state.contractInfo;
    contractInfo.birthday = date;

    this.setState({
      contractInfo,
    });
  };

  deviceChangeHandler = (event, deviceType) => {
    const checked = event.target.checked;
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    validationStates.product = InputValidationType.NULL;

    if (checked) {
      contractInfo.devices.add(deviceType);
      contractInfo.sideInfo[deviceType] = new Set;
    } else {
      contractInfo.devices.delete(deviceType);
      delete contractInfo.sideInfo[deviceType];
    }

    let showOtSessionFee =  this.state.showOtSessionFee;

    if(deviceType.name === 'OT_SESSION')
    {
       showOtSessionFee = checked;
       if (!checked) {
          contractInfo['otSessionAmount'].formattedValue = "";
          contractInfo['otSessionAmount'].value = "";
       }
     }

    let isNeedDisplay = false;
    contractInfo.devices.forEach(deviceType => {
      if (deviceType.isNeedDisplay) {
        isNeedDisplay = true;
      }
    });

    this.setState({
      contractInfo,
      validationStates,
      isNeedDisplay,
      showOtSessionFee
    });
  };

  sideTypeChangeHandler = (event, deviceType, sideType) => {
    let contractInfo = this.state.contractInfo;

    const checked = event.target.checked;

    if (checked) {
      contractInfo.sideInfo[deviceType].add(sideType);
    } else {
      contractInfo.sideInfo[deviceType].delete(sideType);
    }

    this.setState({
      contractInfo
    });
  };

  displayChangeHandler = displayType => {
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    contractInfo.display = displayType;
    validationStates.display = InputValidationType.NULL;
    this.setState({
      contractInfo,
      validationStates,
    });
  };


  calculateTotalAmount = contractInfo => {
    let installmentPeriod = contractInfo.installmentPeriod
    let hardwareAmount = contractInfo.hardwareAmount.value
    let otSessionAmount = contractInfo.otSessionAmount.value
    let oneTimeAmount = contractInfo.oneTimeAmount.value

    let totalAmount = {value: 0, formatted: ''};

    if(installmentPeriod && hardwareAmount)
    {
      totalAmount.value+=hardwareAmount*installmentPeriod
    }

    if(otSessionAmount)
    {
      totalAmount.value+=otSessionAmount
    }

    if(oneTimeAmount)
    {
      totalAmount.value+=oneTimeAmount
    }

    const scientificNotation = Math.pow(10, 2 * -1);
    totalAmount.formatted = totalAmount.value * scientificNotation;

    return totalAmount;
  };


  validateInstallmentPeriod = value => {
    let month = parseInt(value);
    if (isNaN(month)) {
      month = 1;
    }

    return month;
  };

  installmentPeriodChangeHandler = values => {
    const {value} = values;

    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    contractInfo.installmentPeriod = this.validateInstallmentPeriod(value);
    validationStates.installmentPeriod = InputValidationType.NULL;

    contractInfo.totalAmount = this.calculateTotalAmount(contractInfo);

    this.setState({
      contractInfo,
      validationStates,
    });
  };



  installmentPeriodSelectorChangeHandler = eventKey => {
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    contractInfo.installmentPeriod = eventKey;
    validationStates.installmentPeriod = InputValidationType.NULL;

    contractInfo.totalAmount = this.calculateTotalAmount(contractInfo);

    this.setState({
      contractInfo,
      validationStates,
    });
  };

  amountChangeHandler = (values, amountKey) => {
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;

    const {formattedValue, value} = values;

    contractInfo[amountKey].formattedValue = formattedValue;
    if (this.state.region === 'KR') {
      contractInfo[amountKey].value = value;
    } else {
      contractInfo[amountKey].value = value * 100;
    }

    validationStates.amount = InputValidationType.NULL;

    contractInfo.totalAmount = this.calculateTotalAmount(contractInfo);

    this.setState({
      contractInfo,
      validationStates,
    });
  };

  nextPaymentDateChangeHandler = date => {
    let contractInfo = this.state.contractInfo;
    contractInfo.nextPaymentDate = date;

    this.setState({
      contractInfo,
    });
  };

  postalCodeChangeHandler = event => {
    let contractInfo = this.state.contractInfo;
    let validationStates = this.state.validationStates;
    contractInfo.postalCode = event.target.value;
    validationStates.postalCode = InputValidationType.NULL;
    this.setState({
      contractInfo,
      validationStates,
    });
  };

  validateEmail = (cb) => {
    const isNewCustomer = this.state.isNewCustomer;
    const email = this.state.contractInfo.email;
    let validationStates = this.state.validationStates;
    let hasActiveContract = this.state.hasActiveContract;
    let help = this.state.help;
    help.email = null;

    if (IsEmail.validate(email)) {
      checkEmail(email, (err, result) => {
        let validEmail = true;
        if (err) {
          Messenger().post({
            type: 'error',
            message: `${err.statusMessage} (${err.statusCode})`,
            showCloseButton: true,
          });
          validEmail = false;
        } else {
          if (result.statusCode === 0 || result.statusCode === '0') {
            if (isNewCustomer ^ result.inUse) {
              validationStates.email = InputValidationType.SUCCESS;
              validEmail = true;
              hasActiveContract = result.hasActiveContract;
            } else {
              validationStates.email = InputValidationType.ERROR;
              if (isNewCustomer) {
                help.email = 'Email already in use.';
              } else {
                help.email = 'There is no user information matching the email you entered.';
              }
              validEmail = false;
            }
            this.setState({
              hasActiveContract,
              validationStates,
              help,
            });
          } else {
            Messenger().post({
              type: 'error',
              message: `${result.statusCode}`,
              showCloseButton: true,
            });

            validEmail = false;
          }
        }

        cb(validEmail);
      });
    } else {
      validationStates.email = InputValidationType.ERROR;

      this.setState({
        validationStates,
        help,
      }, () => {
        cb(false);
      });
    }
  };

  confirmClickHandler = () => {
    this.checkInputValidation((result) => {
      if (result) {
        if (this.state.hasActiveContract) {
          this.showContractExpireModal();
        } else {
          this.saveContract();
        }
      }
    });
  };

  saveContract() {
    let contract = this.getContractData();
    this.setState({
      loaded: false,
    });

    createContract(contract, (err, result) => {
      this.setState({
        loaded: true,
      });

      if (err) {
        console.error('createContract err : ', err);

        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        if (result.statusCode === 0 || result.statusCode === '0') {
          Messenger().post({
            type: 'success',
            message: `상품이 성공적으로 저장되었습니다.`,
            showCloseButton: true,
          });

          this.setState({
            billingUrl: result.paymentUrl,
          }, () => this.showSuccessModal());
        } else {
            let errorMessage = result.statusMessage  ? `${result.statusMessage}` : `${result.statusCode}`;
          Messenger().post({
            type: 'error',
            message: errorMessage,
            showCloseButton: true,
          });
        }
      }
    });
  }

  getContractData() {
    const contractInfo = this.state.contractInfo;
    let contract = {};

      // set common contract info
      {
        contract.countryCode                = this.state.region;
        contract.email                      = contractInfo.email;
        contract.installmentPeriod          = contractInfo.installmentPeriod;
        contract.hardwareAmount             = contractInfo.hardwareAmount.value || 0;
        contract.otSessionAmount            = contractInfo.otSessionAmount.value || 0;
        contract.oneTimeAmount              = contractInfo.oneTimeAmount.value || 0;
        contract.postalCode                 = contractInfo.postalCode;
        contract.nextPaymentDate            = moment(contractInfo.nextPaymentDate).format('YYYY-MM-DD');

      let devices = {
        medicalDevice: [],
      };

      contractInfo.devices.forEach(deviceType => {
        let medicalDevice = {
          deviceType: deviceType.name,
        };

        if (deviceType.isSidedDevice) {
          medicalDevice.side = [];

          contractInfo.sideInfo[deviceType].forEach(sideType => {
            medicalDevice.side.push(sideType.name);
          });
        }
        devices.medicalDevice.push(medicalDevice);

        if (this.state.isNeedDisplay && contractInfo.display) {
          devices.androidDevice = {
            deviceType: contractInfo.display.deviceType,
            deviceCode: contractInfo.display.deviceCode,
            deviceName: contractInfo.display.deviceName,
          };
        }
      });

      contract.devices = JSON.stringify(devices);
    }

    // set new customer contract info
    if (this.state.isNewCustomer) {
      contract.password = this.state.contractInfo.password;

      if (this.state.region === 'KR') {
        contract.firstName = contractInfo.firstName;
        contract.lastName = contractInfo.lastName;
        contract.nickname = contractInfo.lastName + contractInfo.firstName;
      } else {
        contract.nickname = contractInfo.nickname;
      }

      contract.gender = contractInfo.gender.name;

      contract.birthday = moment(contractInfo.birthday).format('YYYY-MM-DD');
    }

    return contract;
  }

  checkInputValidation(cb) {
    let isValid = true;

    this.validateEmail((result) => {
      isValid = result;

      console.log('start another validation');
      let validationStates = this.state.validationStates;
      let contractInfo = this.state.contractInfo;
      let help = this.state.help;

      if (this.state.isNewCustomer) {
        help.password = null;
        help.confirmPassword = null;
        if (contractInfo.password.length < 8 || contractInfo.password.length > 40) {
          validationStates.password = InputValidationType.ERROR;
          help.password = 'Password must be 8 to 40 characters.';
          isValid = false;
        } else if (contractInfo.password !== contractInfo.confirmPassword) {
          validationStates.password = InputValidationType.ERROR;
          help.confirmPassword = 'Passwords do not match.';
          isValid = false;
        } else {
          validationStates.password = InputValidationType.SUCCESS;
          help.password = null;
        }

        if (this.state.region === 'KR') {
          if (contractInfo.firstName.length > 0 && contractInfo.lastName.length > 0) {
            validationStates.name = InputValidationType.SUCCESS;
          } else {
            validationStates.name = InputValidationType.ERROR;
            isValid = false;
          }
        } else {
          if (contractInfo.nickname.length > 0) {
            validationStates.name = InputValidationType.SUCCESS;
          } else {
            validationStates.name = InputValidationType.ERROR;
            isValid = false;
          }
        }

        if (contractInfo.gender === null) {
          validationStates.gender = InputValidationType.ERROR;
          isValid = false;
        } else {
          validationStates.gender = InputValidationType.SUCCESS;
        }

        if (contractInfo.birthday !== null) {
          validationStates.birthday = InputValidationType.SUCCESS;
        } else {
          validationStates.birthday = InputValidationType.ERROR;
          isValid = false;
        }
      }

      if (contractInfo.devices.size > 0) {
        validationStates.product = InputValidationType.SUCCESS;

        contractInfo.devices.forEach(deviceType => {
          if (deviceType.isSidedDevice && contractInfo.sideInfo[deviceType].size === 0) {
            validationStates.product = InputValidationType.ERROR;
            isValid = false;
          }

          if (deviceType.isNeedDisplay && contractInfo.display === null) {
            validationStates.display = InputValidationType.ERROR;
            isValid = false;
          } else {
            validationStates.display = InputValidationType.SUCCESS;
          }
        });
      } else {
        validationStates.product = InputValidationType.ERROR;
        isValid = false;
      }

      if (contractInfo.installmentPeriod > 0) {
          validationStates.installmentPeriod = InputValidationType.SUCCESS;
      } else {
        validationStates.installmentPeriod = InputValidationType.ERROR;
        isValid = false;
      }

      if (contractInfo.hardwareAmount.value > 0 || contractInfo.oneTimeAmount.value > 0 || contractInfo.otSessionAmount.value > 0) {
        validationStates.amount = InputValidationType.SUCCESS;
      } else {
        validationStates.amount = InputValidationType.ERROR;
        isValid = false;
      }

      if (contractInfo.postalCode > 0) {
        validationStates.postalCode = InputValidationType.SUCCESS;
      } else {
        validationStates.postalCode = InputValidationType.ERROR;
        isValid = false;
      }

      this.setState({
        validationStates,
        help,
      });

      console.log('End another validation');
      cb(isValid);
    });
  }

  getSideDevice = (deviceType) => {
    return (
        <StyledFormGroup>
          <Col componentClass={ControlLabel} xs={1}>
            Side
          </Col>
          <Col xs={11}>
            {
              SideType.enumValues.map(
                  sideType => (
                      <Checkbox
                          inline
                          key={sideType}
                          id={sideType.name}
                          name={`${deviceType.name}_side_selector`}
                          onClick={event => this.sideTypeChangeHandler(event, deviceType, sideType)}
                      >
                        {sideType.title}
                      </Checkbox>
                  ))
            }
          </Col>
        </StyledFormGroup>
    );
  };

  showSuccessModal() {
    this.setState({showSuccessModal: true});
  };

  closeSuccessModal() {
    this.setState({showSuccessModal: false});
  };

  showContractExpireModal() {
    this.setState({showContractExpireModal: true});
  };

  closeContractExpireModal() {
    this.setState({showContractExpireModal: false});
  };

  contractExpireModalButtonClickHandler(confirm) {
    if (confirm) {
      this.saveContract();
    }
    this.closeContractExpireModal();
  };

  partialInstallmentChangeHandler = (event) => {
    let contractInfo = this.state.contractInfo;
    contractInfo.partialInstallment = !contractInfo.partialInstallment;
    this.setState({
      contractInfo
    });
  };

  render() {
    const validationStates = this.state.validationStates;
    const contractInfo = this.state.contractInfo;

    const passwordInputForm = (
        <TextInputForm
            key="password_input_form"
            validationState={validationStates.password}
            label="Password"
            type="password"
            placeholder="At least 8 characters"
            value={contractInfo.password}
            valueChangeHandler={(event) => this.textInputChangeHandler(event, 'password', 'password', 'password')}
            help={this.state.help.password}
        />
    );

    const confirmPasswordInputForm = (
        <TextInputForm
            key="confirm_password_input_form"
            validationState={validationStates.password}
            label="Confirm password"
            type="password"
            placeholder="Confirm password"
            value={contractInfo.confirmPassword}
            valueChangeHandler={(event) => this.textInputChangeHandler(event, 'confirmPassword', 'password',
                'confirmPassword')}
            help={this.state.help.confirmPassword}
        />
    );

    let userNameInputForm = null;
    if (this.state.region === 'KR') {
      userNameInputForm = (
          <StyledFormGroup validationState={validationStates.name.validationName} key="user_name_input_form">
            <Col xs={3} componentClass={ControlLabel}>
              Patient Name
            </Col>
            <Col xs={3}>
              <FormControl
                  type="text"
                  placeholder="Input patient first name"
                  value={contractInfo.firstName}
                  onChange={(event) => this.textInputChangeHandler(event, 'firstName', 'name')}
              />
            </Col>
            <Col xs={3}>
              <FormControl
                  type="text"
                  placeholder="Input patient last name"
                  value={contractInfo.lastName}
                  onChange={(event) => this.textInputChangeHandler(event, 'lastName', 'name')}
              />
            </Col>
          </StyledFormGroup>
      );
    } else {
      userNameInputForm = (
          <TextInputForm
              key="user_name_input_form"
              validationState={validationStates.name}
              label="Patient Nickname"
              type="text"
              placeholder="Input patient nickname"
              value={contractInfo.nickname}
              valueChangeHandler={(event) => this.textInputChangeHandler(event, 'nickname', 'name')}
          />
      );
    }

    const genderInputForm = (
        <StyledFormGroup validationState={validationStates.gender.validationName} key="gender_input_form">
          <Col xs={3} componentClass={ControlLabel}>
            Gender
          </Col>
          <Col xs={9}>
            {
              GenderType.enumValues.map(genderType => (
                  <Radio
                      inline
                      key={genderType}
                      id={genderType.name}
                      name="gender_selector"
                      defaultChecked={genderType === GenderType.MALE}
                      onClick={() => this.genderTypeChangeHandler(genderType)}
                  >
                    {genderType.title}
                  </Radio>
              ))
            }
          </Col>
        </StyledFormGroup>
    );

    const birthdayInputForm = (
        <StyledFormGroup validationState={validationStates.birthday.validationName} key="birthday_input_form">
          <Col xs={3} componentClass={ControlLabel}>
            Birthday
          </Col>
          <Col xs={9}>
            <DatePicker
                locale="en"
                className="form-control"
                selected={contractInfo.birthday}
                onChange={(date) => this.birthdayChangeHandler(date)}
                placeholderText="Click to select a date"
                withPortal
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                minDate={moment().subtract(120, 'years').toDate()}
                maxDate={moment().toDate()}
                dateFormat={DEFAULT_DATE_FORMAT}
                dropdownMode="select"
            />
          </Col>
        </StyledFormGroup>
    );

    const newCustomerInputForm = [
      passwordInputForm,
      confirmPasswordInputForm,
      userNameInputForm,
      genderInputForm,
      birthdayInputForm,
    ];

    let numberInputFormatProps = {
      className: 'form-control',
      thousandSeparator: true,
      decimalScale: 2,
      fixedDecimalScale: true,
      allowNegative: false,
    };

    if (this.state.region === 'KR') {
      numberInputFormatProps.decimalScale = 0;
    }

    return (
        <Grid>
          <Row>
            <Col sm={12}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className="bg-pinkishred fg-white">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            Payment
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 25}}>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <Form horizontal>
                            <StyledFormGroup controlId="countrySelect">
                              <Col xs={3} componentClass={ControlLabel}>
                                Country
                              </Col>
                              <Col xs={9}>
                                <FormControl
                                    componentClass="select"
                                    onChange={this.countryChangeHandler}
                                    value={this.state.region}
                                    style={{width: '120px'}}
                                >
                                  {
                                    this.state.serviceRegions.map(serviceRegion => (
                                        <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                          {serviceRegion.countryAlpha3Code}
                                        </option>
                                    ))
                                  }
                                </FormControl>
                              </Col>
                            </StyledFormGroup>
                            <StyledFormGroup>
                              <Col xs={3} componentClass={ControlLabel}>
                                New customer or Existing customer
                              </Col>
                              <Col xs={9}>
                                {
                                  CustomerType.enumValues.map(customerType => (
                                      <Radio
                                          inline
                                          key={customerType}
                                          id={customerType.name}
                                          name="customer_type_selector"
                                          defaultChecked={customerType === CustomerType.NEW_CUSTOMER}
                                          onClick={() => this.customerTypeChangeHandler(customerType)}
                                      >
                                        {customerType.title}
                                      </Radio>
                                  ))
                                }
                              </Col>
                            </StyledFormGroup>
                            <TextInputForm
                                validationState={validationStates.email}
                                label="Customer's Email"
                                type="email"
                                placeholder="Input email address"
                                value={contractInfo.email}
                                valueChangeHandler={(event) => this.textInputChangeHandler(event, 'email', 'email')}
                                help={this.state.help.email}
                            />
                            {
                              this.state.isNewCustomer ? newCustomerInputForm : null
                            }
                            <StyledFormGroup validationState={validationStates.product.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                Products
                              </Col>
                              <Col xs={9}>
                                {
                                  DeviceType.enumValues.map(deviceType => {
                                    return (
                                        <div key={deviceType}>
                                          <Checkbox
                                              name="device"
                                              onChange={event => this.deviceChangeHandler(event, deviceType)}
                                              checked={contractInfo.devices.has(deviceType)}
                                          >
                                            {deviceType.title}
                                          </Checkbox>
                                          {
                                            deviceType.isSidedDevice &&
                                            contractInfo.devices.has(deviceType) ? this.getSideDevice(deviceType) : null
                                          }
                                        </div>
                                    );
                                  })
                                }
                              </Col>
                            </StyledFormGroup>
                            {
                              this.state.isNeedDisplay ? (
                                  <StyledFormGroup validationState={validationStates.display.validationName}>
                                    <Col xs={3} componentClass={ControlLabel}>
                                      Display
                                    </Col>
                                    <Col xs={9}>
                                      {
                                        DisplayType.enumValues.map(display => (
                                            <Radio
                                                key={display}
                                                id={display.name}
                                                name="display_selector"
                                                onClick={() => this.displayChangeHandler(display)}
                                            >
                                              {display.deviceName}
                                            </Radio>
                                        ))
                                      }
                                    </Col>
                                  </StyledFormGroup>
                              ) : null
                            }


                            <StyledFormGroup validationState={validationStates.amount.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                One Time Payments(PIF/Trial Fee)
                              </Col>
                              <Col xs={3}>
                                <InputGroup>
                                  <InputGroup.Addon>{this.state.currency}</InputGroup.Addon>
                                  <NumberFormat
                                      {...numberInputFormatProps}
                                      value={contractInfo.oneTimeAmount.formattedValue}
                                      onValueChange={(values) => this.amountChangeHandler(values, 'oneTimeAmount')}
                                  />
                                </InputGroup>
                              </Col>
                            </StyledFormGroup>



                            <StyledFormGroup validationState={validationStates.amount.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                Installment(per month)
                              </Col>
                              <Col xs={3}>
                                <InputGroup>
                                  <InputGroup.Addon>{this.state.currency}</InputGroup.Addon>
                                  <NumberFormat
                                      {...numberInputFormatProps}
                                      value={contractInfo.hardwareAmount.formattedValue}
                                      onValueChange={(values) => this.amountChangeHandler(values, 'hardwareAmount')}
                                  />
                                </InputGroup>
                              </Col>
                            </StyledFormGroup>

                            {
                              this.state.contractInfo.hardwareAmount.value > 0 ? (
                            <StyledFormGroup validationState={validationStates.installmentPeriod.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                # of installments
                              </Col>
                              <Col xs={9}>
                                <InstallmentPeriodInputGroup>
                                  <InstallmentPeriodInput
                                      className="form-control"
                                      value={contractInfo.installmentPeriod}
                                      allowNegative={false}
                                      isAllowed={(values) => {
                                        const {floatValue} = values;
                                        return (floatValue > 0 && floatValue < 100);
                                      }}
                                      onValueChange={(values) => this.installmentPeriodChangeHandler(values)}
                                  />
                                  <DropdownButton
                                      id="installment_month_dropdown"
                                      componentClass={InputGroup.Button}
                                      title="Select Month"
                                      onSelect={eventKey => this.installmentPeriodSelectorChangeHandler(eventKey)}
                                  >
                                    {
                                      INSTALLMENT_MONTH_LIST.map(monthValue => (
                                          <MenuItem key={monthValue} eventKey={monthValue}>{monthValue}</MenuItem>
                                      ))
                                    }
                                  </DropdownButton>
                                </InstallmentPeriodInputGroup>
                              </Col>
                            </StyledFormGroup>
                            ) : null
                          }

                          {
                              this.state.showOtSessionFee ? (
                                 <StyledFormGroup validationState={validationStates.amount.validationName}>
                                   <Col xs={3} componentClass={ControlLabel}>
                                     OT Session Fee(One Time)
                                   </Col>
                                   <Col xs={3}>
                                     <InputGroup>
                                       <InputGroup.Addon>{this.state.currency}</InputGroup.Addon>
                                       <NumberFormat
                                         {...numberInputFormatProps}
                                         value={contractInfo.otSessionAmount.formattedValue}
                                         onValueChange={(values) => this.amountChangeHandler(values, 'otSessionAmount')}
                                       />
                                     </InputGroup>
                                   </Col>
                                 </StyledFormGroup>
                              ) : null
                            }

                            {
                              this.state.contractInfo.totalAmount.value > 0 ? (
                            <StyledFormGroup validationState={validationStates.amount.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                Total Amount
                              </Col>
                              <Col xs={3}>
                                <span style={{color: "red", fontWeight: "bold"}}> ${this.state.contractInfo.totalAmount.formatted}</span>
                              </Col>
                            </StyledFormGroup>
                              ) : null
                            }

                            <StyledFormGroup validationState={validationStates.nextPaymentDate.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                Next Payment Date
                              </Col>
                              <Col xs={9}>
                                <DatePicker
                                    locale="en"
                                    className="form-control"
                                    selected={contractInfo.nextPaymentDate}
                                    onChange={(date) => this.nextPaymentDateChangeHandler(date)}
                                    placeholderText="Click to select a date"
                                    withPortal
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    minDate={moment().toDate()}
                                    maxDate={moment().add(5, 'months').toDate()}
                                    dateFormat={DEFAULT_DATE_FORMAT}
                                    dropdownMode="select"
                                />
                              </Col>
                            </StyledFormGroup>

                            <StyledFormGroup validationState={validationStates.postalCode.validationName}>
                              <Col xs={3} componentClass={ControlLabel}>
                                Postal Code
                              </Col>
                              <Col xs={3}>
                                <FormControl
                                    type="text"
                                    placeholder="input postal code"
                                    maxLength="10"
                                    value={contractInfo.postalCode}
                                    onChange={event => this.postalCodeChangeHandler(event)}
                                />
                              </Col>
                            </StyledFormGroup>
                          </Form>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelBody>
                  <PanelFooter className="bg-pinkishred fg-white text-right">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                            <Button
                                bsStyle="brownishgray"
                                style={{padding: '0 24px 0 24px'}}
                                onClick={this.confirmClickHandler}
                            >
                              Confirm
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
          <Loader loaded={this.state.loaded} />
          <SuccessModal
              showModal={this.state.showSuccessModal}
              closeModal={this.closeSuccessModal.bind(this)}
              billingUrl={this.state.billingUrl}
          />
          <ContractRegisterModal
              email={this.state.contractInfo.email}
              showModal={this.state.showContractExpireModal}
              closeModal={this.closeContractExpireModal.bind(this)}
              buttonClickHandler={this.contractExpireModalButtonClickHandler.bind(this)}
          />
        </Grid>
    );
  }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/routes/payment/Payment.js